import React from 'react';
import { ManageRegistrationMode } from '../../../types/appTypes';
import AdminRegistrationForm from '../AdminRegistrationForm/AdminRegistrationForm';
import css from './NewRegistrationModal.module.css';

interface NewRegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const NewRegistrationModal = ({ isOpen, onClose }: NewRegistrationModalProps) => {
  if (!isOpen) return null;

  return (
    <div className={css.modalOverlay} onClick={onClose}>
      <div className={css.modalContent} onClick={e => e.stopPropagation()}>
        <div className={css.modalHeader}>
          <h2>New Registration</h2>
          <button className={css.closeButton} onClick={onClose}>×</button>
        </div>
        <div className={css.modalBody}>
          <AdminRegistrationForm 
            mode={ManageRegistrationMode.Create}
            onSuccess={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default NewRegistrationModal; 